import React from "react";
import { Link } from "react-router-dom";
import { Home, Building2, Hammer, Shield, ArrowRight } from "lucide-react";

/**
 * Primary entry CTA for unauthenticated visitors.
 *
 * Replaces the old "Get Started" button with a richer affordance that signals
 * HouseEntry is a multi-role system (Client / Dealer / Builder / Admin) and
 * makes login the explicit entry point — not just a signup action.
 *
 * Variants:
 *   - "primary"  — pill button + role icons row + subtext (used in hero)
 *   - "header"   — compact version for top nav
 */
export default function AccessHouseEntryCTA({ variant = "primary", className = "" }) {
  if (variant === "header") {
    return (
      <Link
        to="/access"
        className={`group inline-flex items-center gap-1.5 btn-gradient rounded-xl px-4 py-2 text-[13px] font-semibold transition-all hover:shadow-lg hover:shadow-blue-500/25 active:scale-95 ${className}`}
        data-testid="access-houseentry-header"
        aria-label="Access Portal"
      >
        Access Portal
        <ArrowRight size={13} className="transition-transform group-hover:translate-x-0.5" />
      </Link>
    );
  }

  // Primary (hero) variant
  return (
    <div className={`flex flex-col items-start gap-3 ${className}`} data-testid="access-houseentry-cta">
      <Link
        to="/access"
        className="group inline-flex items-center gap-2 rounded-xl btn-gradient px-7 py-3.5 text-[15px] font-semibold transition-all duration-200"
        data-testid="access-houseentry-primary"
        aria-label="Get started — choose your role"
      >
        Get Started
        <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
      </Link>
    </div>
  );
}
